<template>
  <div class="product-ccard-container">
    <div class="title">
      <span>卡金会员设置</span>
      <el-tag size="small" type="success" v-if="dataForm.status === 1">上架中</el-tag>
      <el-tag size="small" type="danger" v-if="dataForm.status === 0">下架中</el-tag>
    </div>
    <div class="form">
      <el-form ref="dataForm" :model="dataForm" :rules="dataRules" label-width="90px" size="small">
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item label="卡金名称" prop="name">
              <el-input v-model="dataForm.name" placeholder="请输入卡金名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="可用门店" prop="storeId">
              <el-select size="small" v-model="dataForm.storeId" placeholder="请选择所属门店" multiple filterable
                         clearable style="width: 100%">
                <el-option-group
                  v-for="group in stores"
                  :key="group.label"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="有效期" prop="validTime">
              购买后
              <el-input type="number" v-model="dataForm.validTime" :min="1"
                        style="width: 100px; margin: 0 10px;"></el-input>
              天
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="上架门店页" prop="status">
              <el-switch v-model="dataForm.status" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item label="卡金类型" prop="type">
              <el-radio v-model="dataForm.type" :label="1">普通卡金</el-radio>
              <el-radio v-model="dataForm.type" :label="2">企业卡金</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="goods">
          <div class="item-label">
            <label class="">卡金套餐</label>
          </div>
          <div class="item-box">
            <div v-for="(item, key) in dataForm.goods" :key="key" class="input-item">
              <el-form-item
                label="套餐名称"
                :prop="'goods.' + key + '.name'"
                :rules="[
                {
                  required: true,
                  message: '请输入套餐名称',
                  trigger: 'blur',
                },
              ]"
              >
                <el-input v-model="item.name" placeholder="请输入套餐名称"/>
              </el-form-item>
              <el-form-item
                label="充值"
                :prop="'goods.' + key + '.money'"
                :rules="[
                {
                  required: true,
                  message: '请输入充值金额',
                  trigger: 'blur',
                },
              ]"
              >
                <el-input v-model="item.money" :min="0.01" type="number" placeholder="请输入充值金额（元）"/>
              </el-form-item>
              <el-form-item
                label="卡金"
                :prop="'goods.' + key + '.score'"
                :rules="[
                {
                  required: true,
                  message: '请输入卡金',
                  trigger: 'blur',
                },
              ]"
              >
                <el-input v-model="item.score" :min="1" type="number" placeholder="请输入卡金"/>
              </el-form-item>
              <el-form-item
                  label="新客优惠"
                  :prop="'goods.' + key + '.newcomerDiscount'"
              >
                <el-input v-model="item.newcomerDiscount" :min="0" type="number" placeholder="请输入卡金"/>
              </el-form-item>
              <el-form-item
                  label="老客优惠"
                  :prop="'goods.' + key + '.newcomerDiscount'"
              >
                <el-input v-model="item.loyaltyDiscount" :min="0" type="number" placeholder="请输入卡金"/>
              </el-form-item>
              <div class="delete">
                <i class="el-icon-delete" @click="handleDeleteItem(key)"></i>
                <el-input v-model="item.id" type="hidden"/>
              </div>
            </div>
            <div class="add">
              <el-button type="text" @click="handleAddItem" size="small">+增加套餐</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <div class="title" style="margin-top: 30px;">
      <span>附加收益</span>
    </div>
    <div class="other">
      <div class="item-label">
        <label class="">{{ dataForm.type === 1 ? '闲时优惠' : '项目优惠' }}</label>
      </div>
      <div class="item-box">
        <el-table
          :data="dataForm.service"
          :header-cell-style="{background:'#F2F2F4'}"
          style="width: 100%">
          <el-table-column prop="serviceName" align="center" label="项目"></el-table-column>
          <el-table-column prop="startTime" align="center" label="闲时开始时间" v-if="dataForm.type===1"></el-table-column>
          <el-table-column prop="endTime" align="center" label="闲时结束时间" v-if="dataForm.type===1"></el-table-column>
          <el-table-column prop="money" align="center" label="立减" v-if="dataForm.type===1"></el-table-column>
          <el-table-column prop="money" align="center" label="价格" v-if="dataForm.type===2">
            <template #default="{ row }">
              <el-select v-model="row.discountType" size="small" style="width: 200px">
                <el-option :value="1" label="指定价格"></el-option>
                <el-option :value="2" label="指定折扣"></el-option>
              </el-select>
              <el-input v-model="row.discount" type="number" :min="0" placeholder="请输入价格/折扣" size="small" style="width: 200px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-link
                class="btn"
                type="primary"
                @click="handleShowEditService(scope.row, scope.$index)"
              >
                编辑
              </el-link>
              <el-link
                class="btn"
                type="danger"
                @click="handleDeleteService(scope.$index)"
              >
                删除
              </el-link>
              <el-link
                class="btn"
                :type="scope.row.status === 1 ? 'danger' : 'success'"
                @click="handleStatusService(scope.$index)"
              >
                {{ scope.row.status === 1 ? '停用' : '启用' }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="add">
          <el-button type="text" @click="handleShowAddService" size="small">+增加项目</el-button>
        </div>
      </div>
    </div>
    <br/>
    <div class="other flex">
      <div class="item-label">
        <label class="">闲时时间</label>
      </div>
      <div class="item-box ">
        <el-checkbox-group v-model="dataForm.leisureWorkday">
          <el-checkbox :label="1">星期一</el-checkbox>
          <el-checkbox :label="2">星期二</el-checkbox>
          <el-checkbox :label="3">星期三</el-checkbox>
          <el-checkbox :label="4">星期四</el-checkbox>
          <el-checkbox :label="5">星期五</el-checkbox>
          <el-checkbox :label="6">星期六</el-checkbox>
          <el-checkbox :label="7">星期日</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <br/>
    <div class="other flex">
      <div class="item-label">
        <label class="">券/券包</label>
      </div>
      <div class="item-box add-coupon">
        <el-select v-model="couponForm.couponType" size="small" style="width: 80px">
          <el-option :value="1" label="券"/>
          <el-option :value="2" label="券包"/>
        </el-select>
        <el-input v-model="couponForm.couponId" placeholder="请输入券/券包id" size="small" clearable/>
        <el-button type="text" size="small" @click="handleAddCoupon">+添加</el-button>
      </div>
    </div>
    <div class="other">
      <div class="item-label">
        <label class=""></label>
      </div>
      <div class="item-box coupon-list">
        <el-tag v-for="(tag, index) in dataForm.coupon" :key="tag.couponId" closable @close="handleDelCoupon(index)">
          {{ tag.couponName }}
        </el-tag>
      </div>
    </div>
    <div class="footer">
      <el-button size="small" @click="handleCancel">返 回</el-button>
      <el-button size="small" type="primary" @click="handleSave">保 存</el-button>
    </div>
    <br/>
    <br/>
    <!-- 增加项目 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px">
      <el-form ref="serviceForm" :model="serviceForm" :rules="serviceRules" size="mini" label-position="top">
        <el-form-item label="项目" prop="serviceId">
          <el-select size="small" v-model="serviceForm.serviceId" placeholder="请选择项目" clearable
                     style="width: 100%">
            <el-option v-for="(item, index) in service" :key="index" :label="item.title"
                       :value="item.id" :disabled="existsService.includes(item.id)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="闲时开始时间" prop="startTime" v-if="dataForm.type===1">
          <el-time-picker v-model="serviceForm.startTime" format="HH:mm" value-format="HH:mm"
                          placeholder="请选择闲时开始时间" style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item label="闲时结束时间" prop="endTime" v-if="dataForm.type===1">
          <el-time-picker v-model="serviceForm.endTime" format="HH:mm" value-format="HH:mm"
                          placeholder="请选择闲时结束时间" style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item label="立减" prop="money" v-if="dataForm.type===1">
          <el-input v-model="serviceForm.money" type="number" placeholder="请输入立减金额（元）"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="discountType" v-if="dataForm.type===2">
          <el-select v-model="serviceForm.discountType" size="small">
            <el-option :value="1" label="指定价格"></el-option>
            <el-option :value="2" label="指定折扣"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格/折扣" prop="discount" v-if="dataForm.type===2">
          <el-input v-model="serviceForm.discount" type="number" placeholder="请输入项目价格/折扣"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleAddOrEditService">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dataForm: {
        id: '',
        name: '',
        storeId: [],
        type: 1,
        status: 0,
        validTime: '',
        goods: [],
        service: [],
        coupon: [],
        leisureWorkday: [1,2,3,4,5]
      },
      dataRules: {
        name: [{required: true, message: '请输入卡金名称', trigger: 'blur'}],
        storeId: [{required: true, message: '请选择可用门店', trigger: 'blur'}],
        validTime: [{required: true, message: '请输入有效期', trigger: 'blur'}],
      },
      couponForm: {
        couponType: 1,
        couponId: ''
      },
      /*门店列表*/
      stores: [],
      /*服务列表*/
      service: [],
      serviceMap: {},
      index: '',
      existsService: [],
      dialogVisible: false,
      dialogTitle: '增加项目',
      serviceForm: {
        serviceId: '',
        serviceName: '',
        startTime: '',
        endTime: '',
        money: '',
        discountType: 1,
        discount: '',
        status: 1
      },
      serviceRules: {
        serviceId: [{required: true, message: '请选择项目', trigger: 'blur'}],
        startTime: [{required: true, message: '请输入闲时开始时间', trigger: 'blur'}],
        endTime: [{required: true, message: '请输入闲时结束时间', trigger: 'blur'}],
        money: [{required: true, message: '请输入立减金额', trigger: 'blur'}],
        discount: [{required: true, message: '请输入价格/折扣', trigger: 'blur'}],
      },
    }
  },
  created() {
    this.fetchStore()
    this.fetchService()

    const id = this.$route.query.id;
    if (id) {
      this.fetchDetail(id)
    }
  },
  methods: {
    fetchStore() {
      this.$http.get("store/list").then(({data}) => {
        let storesBusiness = []
        let storesEnd = []
        data.data.forEach(ele => {
          const val = {value: ele.id, label: ele.title};
          if (ele.businessType === 1) {
            storesEnd.push(val) //结业门店
          } else {
            storesBusiness.push(val) //营业门店
          }
        })
        this.stores = [
          {
            label: '营业门店',
            options: storesBusiness
          },
          {
            label: '结业门店',
            options: storesEnd
          },
        ]
      })
    },
    fetchService() {
      this.$http.get("dhaircut/option").then(({data}) => {
        this.service = data.data
        let serviceMap = {}
        data.data.forEach(ele => {
          serviceMap[ele.id] = ele.title
        })
        this.serviceMap = serviceMap
      })
    },
    fetchDetail(id) {
      this.$http.get(`cCard/${id}`).then(({data}) => {
        if (data.code !== 200) {
          this.$alert(data.msg, {
            confirmButtonText: '确定',
            callback: action => {
              this.handleCancel()
            }
          });
          return
        }
        this.dataForm = data.data
      })
    },
    // 项目是否已添加
    getExistsService() {
      let existsService = []
      this.dataForm.service.forEach(ele => {
        existsService.push(ele.serviceId)
      })
      this.existsService = existsService
    },
    // 比较时间
    compareTimes(time1, time2) {
      // 将时间字符串分割为小时和分钟
      let [hours1, minutes1] = time1.split(':').map(Number);
      let [hours2, minutes2] = time2.split(':').map(Number);

      // 转换为分钟
      let totalMinutes1 = hours1 * 60 + minutes1;
      let totalMinutes2 = hours2 * 60 + minutes2;

      // 比较分钟数
      return totalMinutes1 < totalMinutes2;
    },
    /**
     * 增加套餐
     */
    handleAddItem() {
      this.dataForm.goods.push({name: '', money: '', score: ''})
    },
    /**
     * 删除套餐
     */
    handleDeleteItem(index) {
      this.dataForm.goods.splice(index, 1)
    },
    /**
     * 增加项目
     */
    handleShowAddService() {
      this.dialogTitle = '增加项目'
      this.dialogVisible = true
      this.index = ''
      this.serviceForm = {
        serviceId: '',
        serviceName: '',
        startTime: '',
        endTime: '',
        money: '',
        discountType: 1,
        discount: '',
        status: 1
      }
      this.getExistsService()
    },
    /**
     * 编辑项目
     */
    handleShowEditService(row, index) {
      this.dialogTitle = '编辑项目'
      this.dialogVisible = true
      let data = {}
      Object.assign(data, row)
      this.index = index
      this.serviceForm = data
      this.getExistsService()
    },
    /**
     * 增加/编辑项目
     */
    handleAddOrEditService() {
      this.$refs['serviceForm'].validate((valid) => {
        if (valid) {
          if (this.dataForm.type === 1 && !this.compareTimes(this.serviceForm.startTime, this.serviceForm.endTime)) {
            this.$message.error('结束时间不能小于开始时间')
            return
          }
          if (this.dataForm.type === 2 && this.serviceForm.discountType === 2 && this.serviceForm.discount > 10) {
            this.$message.error('折扣不能大于10')
            return
          }
          this.serviceForm.serviceName = this.serviceMap[this.serviceForm.serviceId]
          let data = {}
          Object.assign(data, this.serviceForm)
          if (this.index !== '') {
            this.dataForm.service.splice(this.index, 1)
          }
          this.dataForm.service.push(data)
          this.dialogVisible = false
        }
      });
    },
    /**
     * 删除项目
     */
    handleDeleteService(index) {
      this.dataForm.service.splice(index, 1)
    },
    /**
     * 启停项目
     */
    handleStatusService(index) {
      this.dataForm.service[index].status = this.dataForm.service[index].status === 1 ? 0 : 1
    },
    /**
     * 增加优惠券
     */
    handleAddCoupon() {
      if (!this.couponForm.couponId) {
        this.$message.error('请输入券或者券包id')
        return
      }
      this.$http.get("cCard/queryCoupon", {params: this.couponForm}).then(({data}) => {
        if (data.length === 0) {
          this.$message.error('无此券/券包！！！')
          return
        }
        let existCoupon = []
        this.dataForm.coupon.forEach(els => {
          existCoupon.push(els.id)
        })
        data.forEach(els => {
          if (!existCoupon.includes(els.id)) {
            this.dataForm.coupon.push({couponId: els.id, couponName: els.title})
          }
        })
      })
    },
    handleDelCoupon(index) {
      this.dataForm.coupon.splice(index, 1);
    },
    handleCancel() {
      this.$router.push({path: '/ccard'})
    },
    /**
     * 保存
     */
    handleSave() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.dataForm.leisureWorkday.length === 0) {
            this.$message.error("请选择闲时可用时间")
            return
          }
          this.$http.post("cCard/save", JSON.stringify(this.dataForm)).then(({data}) => {
            if (data.code === 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.handleCancel()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      });
    }
  }
}
</script>
<style scoped lang="less">
.title {
  span {
    margin-right: 10px;
    font-weight: bold;
  }

  font-size: 1.17em;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.goods {
  margin-top: 20px;
  display: flex;
  justify-content: left;

  .item-box {
    padding: 20px;
    border: 1px #EBEEF5 solid;
    border-radius: 5px;

    .input-item {
      overflow: hidden;

      .el-form-item {
        width: 250px;
        float: left;
        padding: 0;
      }

      .delete {
        float: left;
        cursor: pointer;
        margin-top: 3px;
        margin-left: 30px;
      }

      .delete:hover {
        color: #ff6767;
      }
    }

    .add {
      clear: both;
      text-align: center;
    }
  }
}

.item-label {
  width: 78px;
  color: #606266;
  text-align: right;
  font-size: 14px;
  padding: 0 12px 0 0;
  white-space: nowrap;
}

.other {
  display: flex;
  justify-content: left;

  .item-box {
    width: 973px;
  }

  .add {
    width: 100%;
    clear: both;
    text-align: center;
    margin-top: 20px;
  }
}

.flex {
  display: flex;
  align-items: center;
}

::v-deep .el-dialog__body {
  padding-top: 10px;
}

.btn {
  font-size: 12px;
  padding: 0 5px;
}

.add-coupon {
  .el-input {
    width: 200px;
    margin-left: 10px;
  }

  .el-button {
    margin-left: 10px;
  }

  display: flex;
  align-items: center;
}

.coupon-list {
  margin-top: 20px;

  .el-tag {
    margin-right: 10px;
  }
}

.footer {
  margin-top: 80px;
  padding: 10px 0;
  background-color: #F2F6FC;
  width: 100%;
  text-align: center;
}
</style>
